import {createSelector} from 'reselect'

export const getLoading = createSelector(
  state => Boolean(state && state.vehicleParts && state.vehicleParts.detail && state.vehicleParts.detail.isLoading),
  isLoading => isLoading
)
